angular.module("vendorInfo.components", []).component("vendorInfo", {
  templateUrl: "ng/components/vendorInfo/vendorInfo.html",
  bindings: {
    outputGetDetail: "<",
  },
  controller: vendorInfoController,
  controllerAs: "vendorInfoCtrl",
});

function vendorInfoController($searchUserService) {
  var self = this;

  self.updatedEmail = {
    email: null,
    emailPec: null,
  };

  var emailToUpdate = {
    ndg: null,
    mail: null,
    type: null,
  };

  var emailPecToUpdate = {
    ndg: null,
    mail: null,
    type: null,
  };

  self.$onInit = function () {
    self.modifiedEmail = false;
    self.modifiedEmailPec = false;
  };

  self.enableModify = function (property) {
    self[property] = true;
    switch (property) {
      case "modifiedEmail": {
        self.updatedEmail.email = self.outputGetDetail.email;
        break;
      }
      case "modifiedEmailPec": {
        self.updatedEmail.emailPec =
          self.outputGetDetail.emailPec;
      }
    }
  };

  self.handleChange = function (value, property) {
    if (property == "email") {
      emailToUpdate.type = property;
      emailToUpdate.mail = value;
    } else if (property == "emailPec") {
      emailPecToUpdate.type = property;
      emailPecToUpdate.mail = value;
    }
  };

  self.updateInfo = function (propMail, propSave) {
    self[propMail] = false;
    self[propSave] = true;
    emailToUpdate.ndg = self.outputGetDetail.ndg;
    emailPecToUpdate.ndg = self.outputGetDetail.ndg;
    var input = propMail == "modifiedEmail" ? emailToUpdate : emailPecToUpdate;
    $searchUserService
      .saveMail(input)
      .then(function (response) {
        if (response.success) {
          if (input == emailToUpdate) {
            self.outputGetDetail.email =
              emailToUpdate.mail.toUpperCase();
          } else if (input == emailPecToUpdate) {
            self.outputGetDetail.emailPec =
              emailPecToUpdate.mail.toUpperCase();
          }
        }
        self[propSave] = false;
      })
      .catch(function (err) {
        console.log(err);
        self[propSave] = false;
      });
  };
}
